import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from './buttons/button.component';
import { InputComponent } from './input/input.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SelectComponent } from './select/select.component';
import { PageHeaderComponent } from './page-header/page-header.component';
import { AvatarComponent } from '../avatar/avatar.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TablePaginationComponent } from '../../shared/table-pagination/table-pagination.component';

@NgModule({
  declarations: [ButtonComponent, InputComponent, SelectComponent, PageHeaderComponent, AvatarComponent, TablePaginationComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, NgbModule],
  exports: [ButtonComponent, InputComponent, SelectComponent, PageHeaderComponent, AvatarComponent, TablePaginationComponent],
})
export class UiModule {}
